import { useGet } from '../../HttpClient';
import { TransactionReasonModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useTransactionReasons() {
  const get = useGet(true, pillarCode);
  const getTransactionReasons = (): Promise<TransactionReasonModel[]> =>
    get(`${referenceDataBaseUrl}/transaction-reasons`);
  return useQueryWithErrorHandling({
    queryKey: ['get-transaction-reasons'],
    queryFn: async () => await getTransactionReasons(),
  });
}

export function useRefreshTransactionReasons() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-transaction-reasons'] });
}
